import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AlertState {
	level: string;
	message: string;
	open: boolean;
}

const initialState: AlertState = {
	level: "",
	message: "",
	open: false
};

export const alertSlice = createSlice({
	name: "alert",
	initialState,
	reducers: {
		setLevel: (state, action: PayloadAction<string>) => {
			state.level = action.payload;
		},
		setMessage: (state, action: PayloadAction<string>) => {
			state.message = action.payload;
		},
		setOpen: (state, action: PayloadAction<boolean>) => {
			state.open = action.payload;
		}
	}
});

export const selectMessage = (state: { alert: AlertState }) => state.alert.message;
export const selectLevel = (state: { alert: AlertState }) => state.alert.level;
export const selectOpen = (state: { alert: AlertState }) => state.alert.open;

export const {
	setLevel,
	setMessage,
	setOpen
} = alertSlice.actions;

export default alertSlice.reducer;
